// Hintergrund-Videos (Modul „medien-banner", Medientyp „Video"): stummes Loop.
// Das Markup liefert autoplay/muted/loop/playsinline bereits mit; dieses Modul
// erzwingt nur die Accessibility-Regel: bei prefers-reduced-motion KEIN Autoplay
// -> Video pausiert, das poster-Bild bleibt stehen (§16). Reagiert live auf
// Änderungen der Einstellung. Kein Inline-JS (§8).
//   <video class="medien-banner__media" data-bg-video autoplay muted loop playsinline poster="…">
export function initBgVideo() {
  const videos = document.querySelectorAll("video[data-bg-video]");
  if (videos.length === 0) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  const apply = () => {
    videos.forEach((video) => {
      if (reduce.matches) {
        video.removeAttribute("autoplay");
        video.pause();
      } else {
        const played = video.play();
        if (played && typeof played.catch === "function") {
          played.catch(() => {});
        }
      }
    });
  };

  apply();
  reduce.addEventListener("change", apply);
}
